<template>
  <div class="remaining-time-in-days-cell-renderer">
    <span :classes="text.classes">
      {{ text.value }}
    </span>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue'
import dayjs from 'dayjs'
import pluralize from 'pluralize'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const valuesDictionary = computed(() => {
  return {
    empty: {
      value: params.value.emptyText,
      classes: 'text-disabled font-italic',
    },
    overdue: {
      value: daysOverdue.value,
      classes: 'text-danger font-weight-bold',
    },
    today: {
      value: 'due today',
      classes: 'text-danger font-weight-bold',
    },
    valid: {
      value: remainingDays.value,
      classes: '',
    },
    warning: {
      value: remainingDays.value,
      classes: 'text-danger font-weight-bold',
    },
  }
})

const emptyValue = computed(() => params.value.value !== 0 && !params.value.value)

const daysOverdue = computed(() => {
  return `${remainingDays.value * -1} ${pluralize('day', remainingDays.value * -1)} overdue`
})

const remainingDays = computed(() => {
  if (emptyValue.value) return null

  const endDate = dayjs(params.value.value)
  const today = dayjs()

  return endDate.diff(today, 'd')
})

const text = computed(() => {
  if (emptyValue.value) return valuesDictionary.value.empty
  if (remainingDays.value === 0) return valuesDictionary.value.empty
  if (remainingDays.value < 0) return valuesDictionary.value.overdue
  if (params.value.warning && remainingDays.value <= params.value.warning) return valuesDictionary.value.warning

  return valuesDictionary.value.valid
})
</script>
